/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import ContactsService from '@/services/ContactsService';
import DwvService from '@/services/DwvService';
import QuickDisplayService from '@/services/QuickDisplayService';
import createEntityFilesThunk from '@/store/slices/components/fileManager/createEntityFilesThunk';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`quickDisplay/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getFichaInfoUrl = handler(
  'getFichaInfoUrl',
  QuickDisplayService.getFichaInfoUrl
);

export const getQuickPropData = handler(
  'getQuickPropData',
  QuickDisplayService.getQuickPropData
);

export const getQuickOpenNaventData = handler(
  'getQuickOpenNaventData',
  QuickDisplayService.getQuickOpenNaventData
);

export const getQuickExternalNetworkData = handler(
  'getQuickExternalNetworkData',
  ({ id, outerNet }) =>
    QuickDisplayService.getQuickExternalNetworkData(id, outerNet)
);

export const getQuickDevData = handler(
  'getQuickDevData',
  QuickDisplayService.getQuickDevData
);

export const getHighLightContacts = handler(
  'getHighLightContacts',
  ContactsService.getContacts
);

export const getSents = handler('getSents', QuickDisplayService.getSents);

export const getDevelopmentSents = handler(
  'getDevelopmentSents',
  QuickDisplayService.getDevelopmentSents
);

const QUICK_FILES_MAP_OPTIONS = { includeLinks: true };

export const getFiles = createEntityFilesThunk(
  'quickDisplay/getFiles',
  'property',
  QuickDisplayService.getFiles,
  QUICK_FILES_MAP_OPTIONS
);

export const getDevelopmentFiles = createEntityFilesThunk(
  'quickDisplay/getDevelopmentFiles',
  'development',
  QuickDisplayService.getDevelopmentFiles,
  QUICK_FILES_MAP_OPTIONS
);

export const starProperty = handler(
  'starProperty',
  QuickDisplayService.starProperty
);

export const starDevelopment = handler(
  'starDevelopment',
  QuickDisplayService.starDevelopment
);

export const toggleFavourite = handler(
  'toggleFavourite',
  QuickDisplayService.toggleFavourite
);

export const toggleFavouriteDevelopment = handler(
  'toggleFavouriteDevelopment',
  QuickDisplayService.toggleFavouriteDevelopment
);

export const isPropOrDevStarred = handler(
  'isPropOrDevStarred',
  QuickDisplayService.isPropOrDevStarred
);

export const fetchDwvPrivateInfo = handler(
  'fetchDwvPrivateInfo',
  DwvService.fetchPrivateInfo
);
